
<div class="alert alert-warning" role="alert" *ngIf="resultsArray.length">
    <h1 class="alert-heading mb-3">{{ title || ('Warning' | localizer:'common.warning' | async) }}</h1>
    <ul class="pl-3">
        <li *ngFor="let result of resultsArray" class='pb-2'>
            {{ result }}
        </li>
    </ul>
</div>